// @ts-nocheck
export function getVersion() {
	const version = '';
	if (version.includes('{VERSION}')) {
		return 'development';
	}
	return version;
}
